import * as React from 'react';
import { useQuery } from '@grandvisionhq/graphql';
import '../../operations/queries/get-place-by-id.js';
import '../../operations/queries/get-stores-by-distance.js';
import '../../operations/queries/get-store-by-code.js';
import '../../operations/queries/get-store-by-id.js';
import '../../operations/queries/get-store-details.js';
import '../../operations/queries/get-nearest-stores.js';
import { GET_PREFERRED_STORE_WITH_INVENTORY, GET_PREFERRED_STORE } from '../../operations/queries/get-preferred-store.js';
import '../../operations/queries/get-preferred-store-id.js';
import '../../operations/queries/get-preferred-store-code.js';
import '../../operations/queries/stores-search.js';
import { mapStoreResult } from './adapters/mapStoresResult.js';
import '../../types.js';

const useGetPreferredStore = ({ onError , sku  } = {})=>{
    const query = useQuery(sku ? GET_PREFERRED_STORE_WITH_INVENTORY : GET_PREFERRED_STORE, {
        variables: {
            sku
        },
        onError (error) {
            onError === null || onError === void 0 ? void 0 : onError(error, 'stores.storeDetailsRoot.preferredStoreFetch.error');
        }
    });
    const data = React.useMemo(()=>{
        var ref, ref1;
        if ((ref = query.data) === null || ref === void 0 ? void 0 : (ref1 = ref.me) === null || ref1 === void 0 ? void 0 : ref1.preferredStore) {
            var ref2, ref3;
            return mapStoreResult((ref2 = query.data) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.me) === null || ref3 === void 0 ? void 0 : ref3.preferredStore);
        }
        return null;
    }, [
        query
    ]);
    return {
        data,
        loading: query.loading,
        error: query.error
    };
};

export { useGetPreferredStore as default };
//# sourceMappingURL=use-get-preferred-store.js.map
